import classNames from "classnames";
import { useState } from "react";
import { CartItem as CartItemType } from "../../../assets/interfaces";
import { getItemThumbnail } from "@/assets/js/utils/utils";
import { capitalizeFirstLetter } from "@/assets/js/utils/functions";

const CartMainItem: React.FC<{ deactivated?: boolean; hideButton?: boolean; items: CartItemType[] }> = ({
  deactivated = false,
  children,
  items,
}) => {
  const [showContent, setShowContent] = useState(true);
  const transition = "transition-all ease-out duration-300";

  const accordionClasses = classNames(transition, {
    "max-h-0 px-3 py-2 hidden overflow-hidden": !showContent,
    "px-3 py-2 flex flex-col gap-y-3": showContent,
  });
  const itemsLength = items?.length;

  return (
    <div className={`${showContent ? "rounded-15 relative border border-grey-border border-opacity-50" : ""}`}>
      <div
        className={`flex px-3 py-2 relative ${
          showContent ? "border-b border-grey-border rounded-t-15" : "rounded-15 border border-grey-border"
        } bg-grey-fields-200 items-center justify-between border-opacity-50 ${!deactivated && "cursor-pointer"}`}
        onClick={() => !deactivated && setShowContent(!showContent)}
      >
        <div className="py-2 flex items-stretch cursor-pointer overflow-hidden">
          <figure className={`h-[44px] w-[44px] sm:h-12.5 sm:w-12.5 rounded-10 overflow-hidden flex-shrink-0`}>
            <img src={getItemThumbnail(items[0]?.item)} alt="" className="h-full w-full object-cover" />
          </figure>
          <div className="ml-3.75 flex flex-col gap-y-1 flex-1 overflow-hidden">
            <h5
              className={`text-black font-display font-bold overflow-hidden text-sm sm:text-1sm max-w-full whitespace-nowrap overflow-ellipsis `}
            >
              {capitalizeFirstLetter(items[0]?.item?.name)}{" "}
            </h5>
            <div className="flex w-full items-center gap-1.5 justify-between">
              <div className="">
                {/* prettier ignore */}
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
                  <g clip-path="url(#clip0_1082_5014)">
                    <path
                      d="M14 8C14 4.13401 10.866 1 7 1C3.13401 1 0 4.13401 0 8C0 11.866 3.13401 15 7 15C10.866 15 14 11.866 14 8Z"
                      fill="#39B588"
                    />
                    <path
                      d="M6.0055 10.625C5.86543 10.625 5.73237 10.5664 5.63432 10.4639L3.65233 8.39096C3.44922 8.17854 3.44922 7.82695 3.65233 7.61454C3.85543 7.40212 4.1916 7.40212 4.3947 7.61454L6.0055 9.29922L9.6053 5.53431C9.8084 5.3219 10.1446 5.3219 10.3477 5.53431C10.5508 5.74673 10.5508 6.09832 10.3477 6.31073L6.37669 10.4639C6.27864 10.5664 6.14557 10.625 6.0055 10.625Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1082_5014">
                      <rect width="14" height="15" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <p className="text-1xs md:text-sm text-black-muted">
                {itemsLength} {itemsLength > 1 ? "options" : "option"} selected
              </p>
            </div>
          </div>
        </div>
        {!deactivated && (
          <button
            type="button"
            className={`transition-all duration-100 text-black-secondary ease-out transform ${
              showContent ? "" : "rotate-180"
            }`}
          >
            {/* prettier-ignore */}
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M16.5 13.75L11 8.25L5.5 13.75" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" transform="translate(0 0.5)"/>
              </svg>
          </button>
        )}
      </div>
      <div className={accordionClasses}>{children}</div>
    </div>
  );
};
export default CartMainItem;
